import toggleCharm from '../actions/toggleCharm';
import { mutator } from 'satcheljs';
import { getStore } from '../store/store';
mutator(toggleCharm, function (actionMessage) {
    var charm = actionMessage.charm;
    var store = getStore();
    if (store.activeCharm === charm) {
        store.activeCharm = null;
    }
    else {
        store.activeCharm = charm;
    }
});
//# sourceMappingURL=toggleCharm.js.map